import { Component, OnInit, inject, EventEmitter, Output } from "@angular/core";

import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { SharedModule } from "../../../shared/shared.module";
import { VendorService } from "../vendor.service";
import { AlertService } from "../../../core/service/alert.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-invite-vendor-modal",
  standalone: true,
  imports: [SharedModule, ReactiveFormsModule],
  templateUrl: "./invite-vendor-modal.component.html",
  styleUrls: ["./invite-vendor-modal.component.css"],
})
export class InviteVendorModalComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly vendorService = inject(VendorService);
  private readonly alertService = inject(AlertService);
  private readonly router = inject(Router);

  @Output() modalClosed = new EventEmitter<void>();

  isModalOpen = false;
  inviteVendorFormGroup!: FormGroup;
  isInviteLoading = false;
  countryCode = "+91";

  constructor() {
    // Initialize form immediately to avoid undefined errors
    this.initializeForm();
  }

  ngOnInit(): void {
    // Form already initialized in constructor
  }

  /**
   * Initialize the invite vendor form
   */
  private initializeForm(): void {
    this.inviteVendorFormGroup = this.formBuilder.group({
      companyUserName: ["", Validators.required],
      EmailId: ["", [Validators.required, Validators.email]],
      phoneNumber: ["", Validators.required],
    });
  }

  /**
   * Open the modal
   */
  openModal(): void {
    this.isModalOpen = true;
    if (this.inviteVendorFormGroup) {
      this.inviteVendorFormGroup.reset();
    }
  }

  /**
   * Close the modal
   */
  closeModal(): void {
    this.isModalOpen = false;
    if (this.inviteVendorFormGroup) {
      this.inviteVendorFormGroup.reset();
    }
    // Emit event to notify service to clean up
    this.modalClosed.emit();
  }

  /**
   * Handle country change for phone input
   */
  onCountryChange(event: any): void {
    if (event?.dialCode) {
      this.countryCode = event.dialCode;
    }
  }

  /**
   * Send vendor invitation
   */
  sendInvite(): void {
    // Mark all fields as touched to show validation errors
    Object.keys(this.inviteVendorFormGroup.controls).forEach((key) => {
      this.inviteVendorFormGroup.get(key)?.markAsTouched();
    });

    if (this.inviteVendorFormGroup.invalid) {
      return;
    }

    this.isInviteLoading = true;

    const formData = {
      name: this.inviteVendorFormGroup.value.companyUserName,
      email_id: this.inviteVendorFormGroup.value.EmailId,
      country_code: this.countryCode || "+91",
      mobile_number: this.inviteVendorFormGroup.value.phoneNumber,
    };

    this.vendorService.inviteVendor(formData).subscribe({
      next: (res: any) => {
        this.isInviteLoading = false;
        if (res.status) {
          this.alertService.showAlert(
            "Success!",
            res.message || "Vendor invited successfully!",
            "success"
          );
          this.closeModal();
        } else {
          this.alertService.showAlert(
            "Error!",
            res.message || "Failed to invite vendor",
            "error"
          );
        }
      },
      error: (err: any) => {
        this.isInviteLoading = false;
        this.alertService.showAlert(
          "Error!",
          err.error?.message ||
            err.error?.error ||
            "There was an error sending the invitation.",
          "error"
        );
      },
    });
  }
}
